import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function AccountPassword() {
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { data } = await supabase.auth.getSession();
      const session = data.session;
      if (!session) {
        navigate("/signin?next=/account/password", { replace: true });
        return;
      }
      setEmail(session.user.email ?? null);
    })();
  }, [navigate]);

  async function setPassword() {
    setErr(null); setOk(null);
    if (!newPw || newPw !== confirm) {
      setErr("Passwords do not match."); return;
    }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: newPw });
    setBusy(false);
    if (error) {
      setErr(error.message + " If this says you must re-authenticate, use the reset email below.");
      return;
    }
    setOk("Password updated. You can now sign in with email + password.");
    setNewPw(""); setConfirm("");
  }

  async function sendResetEmail() {
    if (!email) { setErr("No email for the current user."); return; }
    setErr(null); setOk(null);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) { setErr(error.message); return; }
    setOk("Password reset email sent. Check your inbox and follow the link.");
  }

  return (
    <div style={{ maxWidth: 480, margin: "40px auto", padding: 16, border: "1px solid #eee", borderRadius: 10 }}>
      <h1 style={{ fontSize: 22, marginBottom: 12 }}>Set Password</h1>
      {email && <p style={{ color: "#555" }}>Signed in as <b>{email}</b></p>}

      {err && <div style={{ background: "#ffe8e8", border: "1px solid #f2b0b0", padding: 8, borderRadius: 6, marginBottom: 12, color: "#a40000" }}>{err}</div>}
      {ok &&  <div style={{ background: "#ecfdf5", border: "1px solid #86efac", padding: 8, borderRadius: 6, marginBottom: 12, color: "#166534" }}>{ok}</div>}

      <input type="password" placeholder="New password" value={newPw} onChange={e => setNewPw(e.target.value)} style={input} />
      <input type="password" placeholder="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)} style={input} />
      <button onClick={setPassword} disabled={!newPw || !confirm || busy} style={btnPrimary}>
        {busy ? "Saving…" : "Save password"}
      </button>

      <hr style={{ margin: "16px 0", border: 0, borderTop: "1px solid #eee" }} />

      <p style={{ color: "#555" }}>Can’t update because your session isn’t recent? Send a reset email:</p>
      <button onClick={sendResetEmail} style={btn}>Email me a reset link</button>
    </div>
  );
}

const input: React.CSSProperties = { padding: 10, border: "1px solid #ddd", borderRadius: 6, marginBottom: 10, width: "100%" };
const btn: React.CSSProperties = { padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", background: "#fff", cursor: "pointer", width: "100%" };
const btnPrimary: React.CSSProperties = { ...btn, borderColor: "#0ea5e9", background: "#0ea5e9", color: "#fff" };
